export const EVENT_STATUS = {
    PENDING: { dbValue: 'PENDING', label: 'Pendiente' },
    CONFIRMED: { dbValue: 'CONFIRMED', label: 'Confirmada' },
    IN_PROGRESS: { dbValue: 'IN_PROGRESS', label: 'En progreso' },
    COMPLETED: { dbValue: 'COMPLETED', label: 'Completada' },
    CANCELLED: { dbValue: 'CANCELLED', label: 'Cancelada' },
    POSTPONED: { dbValue: 'POSTPONED', label: 'Pospuesta' },
};

export const EVENT_TYPE = {
    EVENT: { dbValue: 'EVENT', label: 'Evento' },
    TASK: { dbValue: 'TASK', label: 'Tarea' },
    CUSTOM_EVENT: { dbValue: 'CUSTOM_EVENT', label: 'Evento personalizado' },
};

export const getStatusLabel = (status: string) => {
    const found = Object.values(EVENT_STATUS).find(s => s.dbValue === status);
    return found ? found.label : status;
};

export const getTypeLabel = (type: string, dynamicTypeOptions?: any[]) => {
    if (dynamicTypeOptions && dynamicTypeOptions.length > 0) {
        const foundDynamic = dynamicTypeOptions.find(t => t.value === type);
        if (foundDynamic) return foundDynamic.label;
    }
    const found = Object.values(EVENT_TYPE).find(t => t.dbValue === type);
    return found ? found.label : type;
};

export const statusOptions = Object.values(EVENT_STATUS).map(s => ({
    label: s.label,
    value: s.dbValue,
}));

export const typeOptions = Object.values(EVENT_TYPE).map(t => ({
    label: t.label,
    value: t.dbValue,
}));
